export default "__VITE_ASSET__BE25bZtG__"